import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon-history-back.png'
import _imports_1 from '@/assets/logo-top@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-36b68523"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "logo",
  class: "logo--wrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_1,
  alt: "오토콜 로고"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startVARS && _ctx.startVARS(...args))),
      class: _normalizeClass(["icon-history-back", { hidden: !_ctx.showBackButton }]),
      src: _imports_0,
      alt: "뒤로가기 아이콘"
    }, null, 2),
    _hoisted_2
  ]))
}